import BaseModel from '../base/BaseModel.model';
import PorposalBudgetSubItem from './porposalBudgetSubItem.model';
import Document from '../document.model';
export default class ProposalBudgetSubItemExecutionDocument extends BaseModel {

    public proposalBudgetSubItemExecutionId?: number | null;
    public documentId?: number | null;
    public name?: string | null;

    public document?: Document;

    constructor() {
        super();
        this.init();
    }

    init() {
        this.proposalBudgetSubItemExecutionId = null;
        this.documentId = null;
        this.document = null;
        this.name = null;
    }
}